export default __webpack_public_path__ + "static/media/eOsis.72a191ff.jpg";